import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoginHeaderContent } from './models/login-header.interface';

@Component({
  selector: 'idp-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss']
})
export class LoginHeaderComponent {
  @Input() loginHeaderContent!: LoginHeaderContent;
  @Input() checkOutWarmState = false;
  @Input() machCore = false;
  @Output() triggerClose = new EventEmitter();
}
